export const transition = () => {
    return{
        duration: 0.725,
        delay: 0.2,
        ease: 'easeIn',
    }
};
